import z, { ZodType } from "zod";
import { looseUuid } from "./looseUuid.js";
export const PlaceOfSafetyIdSchema = looseUuid().brand();
/**
 * An ODS Code
 */
export const OdsCodeSchema = z.string().min(1).max(255);
/**
 * Types of Place Of Safety
 */
export const PlaceOfSafetyTypeSchema = z.enum([
    "hbPos136",
    "emergencyDepartment",
    "returnedToMentalHealthUnit",
    "careHome",
    "custody",
    "privateHome",
    "other",
]);
export const PlaceOfSafetyConfigSchema = z.object({
    s136ExtensionFormEnabled: z.boolean().default(false),
    outcomeFormEnabled: z.boolean().default(false),
});
export const CuratedPlaceOfSafetySchema = z
    .object({
    id: PlaceOfSafetyIdSchema,
    name: z.string().min(1).max(255),
    address: z.string().min(1).max(255),
    postalCode: z.string().min(1).max(8),
    organisationId: looseUuid()
        .nullish()
        .transform((x) => x ?? undefined),
    odsCode: OdsCodeSchema.nullish().transform((x) => x ?? undefined),
    posType: PlaceOfSafetyTypeSchema.nullish().transform((x) => x ?? undefined),
    trustId: looseUuid()
        .nullish()
        .transform((x) => x ?? undefined),
    trustName: z
        .string()
        .min(1)
        .max(255)
        .nullish()
        .transform((x) => x ?? undefined),
    associatedEmails: z.array(z.email()).optional(),
    config: PlaceOfSafetyConfigSchema.nullish()
        .transform((x) => x ?? undefined)
        .optional(),
})
    .brand();
export const AdHocPlaceOfSafetySchema = z
    .object({
    name: z.string().min(1).max(255, "Name is too long"),
    address: z.string().min(1).max(255, "Address is too long"),
    postalCode: z
        .string()
        .min(1)
        .max(8, "Postal Code may contain up to 8 characters"),
})
    .brand();
//# sourceMappingURL=placeOfSafety.js.map